import React, {useContext} from "react";
import Button from "../../../../common/Button";
import {StartViewPathwayAssignment} from "./axiosRequests";
import TryItIcon from "../../../../common/icons/TryItIcon";
import ScorcherIcon from "../../../../common/icons/ScorcherIcon";
import QuestionSetIcon from "../../../../common/icons/QuestionSetIcon";
import WidgetActivityIcon from "../../../../common/icons/WidgetActivityIcon";
import {UserContext} from "../../../../common/UserContext";
import {BrandContext} from "../../../../common/BrandContext";

const ACTION_TYPE = {
    START_PATHWAY: 'START_PATHWAY',
    VIEW_PATHWAY: 'VIEW_PATHWAY',
}

const ICON_HEIGHT = 40,
    ICON_WIDTH = 40;

const TrailEnums = ()=>{
    const {user} = useContext(UserContext);
    const brandConfig = useContext(BrandContext);
    const {startOrViewPathwayAssignment} = StartViewPathwayAssignment();

    const TRAIL_TABLE_COLUMNS = [
        {
            title: brandConfig.taskName,
            dataIndex: 'planName',
            key: 'planName',
            render: (value) => {
                return(<>
                        <div className="ch-text-emphasis">
                            {value.name}
                        </div>
                        {value.message &&
                            <div>
                                {value.message}
                            </div>
                        }
                        <div>
                            {value.pathwayIcons && value.pathwayIcons.split(',').map((iconClass)=>{
                                if(iconClass === 'tryit-icon'){
                                    return <TryItIcon key={value.key+iconClass} height={ICON_HEIGHT} width={ICON_WIDTH} showTooltip={true}/>;
                                }else if(iconClass === 'questionSet-icon'){
                                    return <QuestionSetIcon key={value.key+iconClass} height={ICON_HEIGHT} width={ICON_WIDTH}  showTooltip={true}/>;
                                }else if(iconClass === 'scorcher-icon'){
                                    return <ScorcherIcon key={value.key+iconClass} height={ICON_HEIGHT} width={ICON_WIDTH}  showTooltip={true}/>;
                                }else if(iconClass === 'widget-icon'){
                                    return <WidgetActivityIcon key={value.key+iconClass} height={ICON_HEIGHT} width={ICON_WIDTH}  showTooltip={true}/>;
                                }
                            })}
                        </div>
                    </>
                )
                // console.log('planName value: ',value);
            }
        },
        {
            title: 'Teacher',
            dataIndex: 'teacher',
            key: 'teacher',
            render:(name)=>{
                return <div>{name}</div>
            }
        },
        {
            title: 'Current lesson',
            dataIndex: 'currentLesson',
            key: 'currentLesson'
        },
        {
            title: 'Step',
            dataIndex: 'currentStep',
            key: 'currentStep',
            render:(value)=>{
                const {complete, totalPathwayUsers, activePathwayUser, pathwayAssignmentUserState} = value;
                let displayStr = '';
                if(complete){
                    if(totalPathwayUsers === 1){
                        if(pathwayAssignmentUserState && pathwayAssignmentUserState !== 'SKIPPED'){
                            displayStr = pathwayAssignmentUserState[0]+pathwayAssignmentUserState.substr(1).toLowerCase();
                        }
                    }
                }else if(activePathwayUser && activePathwayUser.completedStepCount){
                        displayStr = activePathwayUser.completedStepCount;
                }
                return <div>{displayStr}</div>
            }
        },
        {
            title: 'Activity',
            dataIndex: 'activity',
            key: 'activity',
            render:(value)=>{
                const {complete, skippedCount, totalPathwayUsers, activePathwayUser, pathwayAssignmentUserState, activeStep} = value;
                let displayStr = '';
                if(complete){
                    if(skippedCount === totalPathwayUsers){
                        displayStr = 'Skipped';
                    }else{
                        displayStr = 'Completed';
                    }
                }else if(!activePathwayUser && pathwayAssignmentUserState !== 'STARTED'){
                    displayStr = 'In progress';
                }else if(!activePathwayUser){
                    displayStr = 'Not started';
                }else if(activeStep){
                    displayStr = activeStep.stepName;
                }
                return <div>{displayStr}</div>
            }
        },
        {
            title: 'Assigned',
            dataIndex: 'assigned',
            key: 'assigned',
            render:(assignDate)=>{
                return <div>{user.dateFormat.format(assignDate)}</div>
            }
        },
        {
            title: 'Updated',
            dataIndex: 'updated',
            key: 'updated',
            render:(updatedDate)=>{
                return (<div><div>{user.dateFormat.format(updatedDate)},</div>
                    <div>{user.timeFormat.format(updatedDate)}</div></div>)
            }
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (value) => {
                // console.log('value: ',value);
                const {
                    activePathwayUser,
                    totalPathwayUsers,
                    complete,
                    pathwayAssignment,
                    pathwayAssignmentState
                } = value;
                let conceptId,
                    buttonText = 'DEFAULT BUTTON TEXT',
                    actionType,
                    hidden = value.noResults,
                    noResults = value.noResults,
                    disabled = false,
                    pathwayType = pathwayAssignment.pathwayType,
                    pathwayAssignmentId = pathwayAssignment.pathwayAssignmentId;

                if (pathwayAssignment?.concept?.conceptId) {
                    conceptId = pathwayAssignment.concept.conceptId;
                }

                if (activePathwayUser !== undefined && (activePathwayUser.pathwayAssignmentUserState == 'STARTED' || activePathwayUser.pathwayAssignmentUserState == 'PAUSED')) {
                    conceptId = activePathwayUser.concept.conceptId;
                    actionType = ACTION_TYPE.START_PATHWAY;
                    buttonText = 'Resume';
                } else if (pathwayAssignmentState !== 'OPEN') {
                    actionType = ACTION_TYPE.VIEW_PATHWAY;
                    buttonText = 'Results';
                } else if (activePathwayUser !== undefined && activePathwayUser.pathwayAssignmentUserState === 'ASSIGNED') {
                    actionType = ACTION_TYPE.START_PATHWAY;
                    buttonText = 'Start';
                } else if (totalPathwayUsers === 0) {
                    actionType = ACTION_TYPE.START_PATHWAY;
                    buttonText = 'Start';
                } else if (totalPathwayUsers === 1 && activePathwayUser !== undefined && activePathwayUser.pathwayAssignmentUserState === 'SKIPPED') {
                    buttonText = 'Skipped';
                } else if (complete) {
                    actionType = ACTION_TYPE.VIEW_PATHWAY;
                    buttonText = 'Results'
                } else if (pathwayAssignmentState === 'CLOSED') {
                    actionType = ACTION_TYPE.START_PATHWAY;
                    buttonText = 'Resume';
                } else {
                    actionType = ACTION_TYPE.START_PATHWAY;
                    buttonText = 'Resume';
                }
                return <Button size={'medium'} onClick={() => {
                    startOrViewPathwayAssignment({actionType, conceptId, noResults, disabled, pathwayType, pathwayAssignmentId})
                }}>{buttonText}</Button>;
            }
        }
    ];
    return {TRAIL_TABLE_COLUMNS}
}

export {TrailEnums,ACTION_TYPE};